import { jsx as _jsx } from "react/jsx-runtime";
export function VerticalDividerIcon({ className }) {
    return (_jsx("svg", Object.assign({ className: className, width: "1", height: "24", viewBox: "0 0 1 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("rect", { width: "1", height: "24", rx: "0.5", fill: "#E1E5E8" }, void 0) }), void 0));
}
//# sourceMappingURL=VerticalDividerIcon.js.map